import { Button } from '@kalos/ui';

import { type JobLength } from '../utils/multiDay';

type JobLengthSwitchProps = {
  value: JobLength;
  onChange: (value: JobLength) => void;
  disabled?: boolean;
};

const OPTIONS: { value: JobLength; label: string }[] = [
  { value: 'single', label: 'Single day' },
  { value: 'multi', label: 'Multi-day' },
];

/** Single day keeps the time windows; Multi-day swaps them for a start and end date. */
export const JobLengthSwitch = ({ value, onChange, disabled }: JobLengthSwitchProps) => (
  <div className="border-border bg-card flex flex-wrap items-center justify-between gap-3 rounded-lg border p-4 shadow-sm">
    <div>
      <p id="job-length-label" className="text-foreground text-sm font-medium">
        Job length
      </p>
      <p className="text-muted-foreground text-xs">For jobs that run over several days</p>
    </div>
    <div role="group" aria-labelledby="job-length-label" className="flex gap-2">
      {OPTIONS.map((option) => (
        <Button
          key={option.value}
          type="button"
          size="sm"
          variant={value === option.value ? 'default' : 'outline'}
          aria-pressed={value === option.value}
          disabled={disabled}
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  </div>
);
